import axios from 'axios';

type FlagAddressPayload = {
  FulfillmentPlanId: number;
  FraudIndicatorCode: string;
  Reason: string;
};

export const flagAddressForFraud = async (fulfillmentPlanId: string, reason: string): Promise<void> => {
  const payload: FlagAddressPayload = {
    FulfillmentPlanId: parseInt(fulfillmentPlanId, 10),
    FraudIndicatorCode: 'BLACKLIST_EXACT',
    Reason: reason,
  };

  const response = await axios.post('/fraud/manualfraud', payload);
  return response.data;
};
